<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`角色绑定人员列表【${roleName}】`"
    width="1200px"
    height="800px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
      <el-col :span="16" :offset="0">
        <div class="table-main">
          <div class="table-header">
            <el-form ref="searchModel" :model="searchModel" label-width="60px">
              <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                <el-col :span="9" :offset="0">
                  <el-form-item prop="name" label="姓名">
                    <el-input
                      v-model="searchModel.name"
                      placeholder="请输入"
                      clearable
                      @keyup.enter.native.stop="getUserList(true)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15" :offset="0">
                  <el-button type="success" @click="getUserList(true)">查询</el-button>
                  <el-button @click="handleReset">重置</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-table
            ref="table"
            :data="tableData"
            stripe
            border
            height="100%"
            v-loading="tableLoading"
            @select="handleSelection"
            @select-all="handleSelectionAll"
          >
            <el-table-column type="selection" width="55" align="center" :selectable="isSelectable"></el-table-column>
            <el-table-column prop="login_name" label="登录账号" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="120" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="deptName" label="所属部门" align="center"></el-table-column>
            <!-- t-todo:岗位 -->
            <!-- <el-table-column prop="t4" label="岗位" align="center"></el-table-column> -->
            <el-table-column label="状态" align="center">
              <template v-slot="{ row }">
                <el-tag :type="row.deleted === 1 ? 'danger' : 'success'">{{ row.deleted === 1 ? '禁用' : '启用' }}</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="searchModel.pageNum"
            :page-size="searchModel.pageSize"
            background
            layout="total, prev,sizes, pager, next, jumper"
            :total="dataTotal"
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
          ></el-pagination>
        </div>
      </el-col>
      <el-col :span="8" :offset="0">
        <div class="tag-wrap">
          <div class="tag-header">新增绑定用户</div>
          <div class="tag-body">
            <el-tag
              :key="item.id"
              v-for="item in addUserList"
              disable-transitions
              effect="dark"
              closable
              @close="handleRemove(item)"
            >
              {{ item.name }}
            </el-tag>
          </div>
        </div>
        <div class="tag-wrap">
          <div class="tag-header">已绑定用户</div>
          <div class="tag-body">
            <el-tag :key="item.id" v-for="item in activeUserList" disable-transitions effect="dark">
              {{ item.name }}
            </el-tag>
            <el-empty v-if="!activeUserList.length" description="暂无绑定用户"></el-empty>
          </div>
        </div>
      </el-col>
    </el-row>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getUserList, getRoleUserList, saveRoleUser } from '@/api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: [Number, String],
      default: ''
    },
    roleName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchModel: {
        name: '',
        pageNum: 1,
        pageSize: 20
      },
      tableLoading: false,
      dataTotal: 0,
      tableData: [],
      tableSelection: [],
      activeUserList: [],
      addUserList: [],
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    async visible(val) {
      if (val) {
        await this.getRoleUserList();
        this.getUserList();
      }
    }
  },
  methods: {
    // 获取角色已绑定用户列表
    async getRoleUserList() {
      const { data } = await getRoleUserList({ roleId: this.roleId, pageNum: 1, pageSize: 9999 });
      this.activeUserList = data.list || [];
    },
    isSelectable(row) {
      return !this.activeUserList.some(item => item.id === row.id);
    },

    /******** 左侧用户列表 Start ********/
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getUserList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getUserList();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getUserList(true);
    },
    async getUserList(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getUserList(this.searchModel);

      this.tableData = data.list || [];
      // 绑定已选中数据
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          const selected = this.addUserList.some(activeUser => activeUser.id === row.id);
          this.$refs.table.toggleRowSelection(row, selected);
        });
      });
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },
    /******** 用户列表 End ********/

    // 操作
    handleSelection(_, row) {
      const activeIndex = this.addUserList.findIndex(user => user.id === row.id);
      activeIndex > -1 ? this.addUserList.splice(activeIndex, 1) : this.addUserList.push(row);
    },
    handleSelectionAll(val) {
      if (val.length > 0) {
        val.forEach(row => {
          const activeIndex = this.addUserList.findIndex(user => user.id === row.id);
          if (activeIndex == -1) this.addUserList.push(row);
        });
      } else {
        this.tableData.forEach(row => {
          const activeIndex = this.addUserList.findIndex(user => user.id === row.id);
          if (activeIndex > -1) this.addUserList.splice(activeIndex, 1);
        });
      }
    },
    handleRemove(tag) {
      const activeIndex = this.addUserList.findIndex(user => user.id === tag.id);
      this.addUserList.splice(activeIndex, 1);
    },
    async handleSubmit() {
      this.submitLoading = true;
      try {
        const urlist = [];
        this.addUserList.forEach(item => {
          urlist.push({
            roleId: this.roleId,
            user: {
              id: item.id,
              version: item.version
            }
          });
        });

        await saveRoleUser({ urlist: JSON.stringify(urlist) });
        this.$emit('refresh');
        this.$emit('update:visible', false);
        this.$message.success('提交成功!');
      } finally {
        this.submitLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-row,
.el-col {
  height: 100%;
}

.tag-wrap {
  height: 50%;

  .tag-header {
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    color: #303133;
    font-weight: 700;
    height: 40px;
    line-height: 40px;
  }
  .tag-body {
    padding: 10px;
    height: calc(100% - 40px);
    overflow: hidden;
    overflow-y: auto;

    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  ::v-deep .el-empty {
    height: 100%;
    padding: 0;
  }
}
</style>
